import { dateConvert, onlyTime } from "../../../utility/dateModifier";
import { CustomButton } from "../../components/customButton/CustomButton";
import { WHITE_COLOR } from "../../resources/colorsManager";
import { ButtonStyles } from "../../resources/stylesManager";
import { DeveloperSwitch } from "./DeveloperComponent";

const WebhookComponent = ({
  url1,
  url2,
  onClickNotify,
  onClickValidate,
  date,
}) => {
  return (
    <div
      style={{
        backgroundColor: WHITE_COLOR,
        borderRadius: "20px",
        color: "black",
        boxSizing: "border-box",
        display: "flex",
        justifyContent: "space-between",
        padding: "20px 25px",
        flexDirection: "column",
        marginTop: "20px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <DeveloperSwitch title="Webhooks" />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          width: "100%",
          flexDirection: "column",
          backgroundColor: "#F3F3F3",
          borderRadius: "20px",
          padding: "20px",
          marginTop: "10px",
        }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            borderRadius: "20px",
          }}
        >
          {/* Row One */}

          <tr
            style={{
              backgroundColor: "white",
              borderRadius: "20px",
              color: "black",
              fontSize: "16px",
            }}
            className="roboto"
          >
            <td
              style={{
                padding: "20px 20px",
                borderTopLeftRadius: "10px",
                borderBottomLeftRadius: "10px",
              }}
            >
              URL’s
            </td>
            <td>Status</td>
            <td>Events</td>
            <td>Last Update</td>
            <td
              style={{
                padding: "20px 20px",
                borderTopRightRadius: "10px",
                borderBottomRightRadius: "10px",
              }}
            >
              Action
            </td>
          </tr>
          <tr style={{ color: "black", fontSize: "16px" }} className="roboto">
            <td style={{ padding: "20px 20px" }}>{url1 ? url1 : "N/A"}</td>
            <td>
              <CustomButton
                title="Enabled"
                styles={{ ...ButtonStyles, width: "100px" }}
              />
            </td>
            <td>Validate</td>
            <td>
              <p
                style={{ color: "black", fontSize: 16, margin: 0, padding: 0 }}
              >
                {dateConvert(date, false)}
              </p>
              <p
                style={{ color: "black", fontSize: 12, margin: 0, padding: 0 }}
              >
                {onlyTime(date)}
              </p>
            </td>
            <td style={{ padding: "20px 20px" }}>
              <CustomButton
                title="Update"
                styles={{ ...ButtonStyles, width: "100px" }}
                onClick={() => onClickValidate()}
              />
            </td>
          </tr>

          {/* Row Two */}

          <tr style={{ color: "black", fontSize: "16px" }} className="roboto">
            <td style={{ padding: "20px 20px" }}>{url2 ? url2 : "N/A"}</td>
            <td>
              <CustomButton
                title="Enabled"
                styles={{ ...ButtonStyles, width: "100px" }}
              />
            </td>
            <td>Notify</td>
            <td>
              <p
                style={{ color: "black", fontSize: 16, margin: 0, padding: 0 }}
              >
                {dateConvert(date, false)}
              </p>
              <p
                style={{ color: "black", fontSize: 12, margin: 0, padding: 0 }}
              >
                {onlyTime(date)}
              </p>
            </td>
            <td style={{ padding: "20px 20px" }}>
              <CustomButton
                title="Update"
                styles={{ ...ButtonStyles, width: "100px" }}
                onClick={() => onClickNotify()}
              />
            </td>
          </tr>
        </table>
      </div>
    </div>
  );
};

export default WebhookComponent;
